// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3WX_I","tab":"ProcedureTabs_tab__1JDe_"};